import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AskInputPlusMenuFileInputContext } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/providers/AskInputPlusMenuProviderShared.js';
import { ACCEPTED_FILE_TYPES_STRING_ALL } from '#pplx/frontend/components/utils/consts.js';
import React, { useCallback, useMemo, useRef } from 'react';
export const AskInputPlusMenuFileInputProvider = React.memo(function AskInputPlusMenuFileInputProvider({ children, acceptedFileTypes, onFilesSelected, }) {
    const inputRef = useRef(null);
    const acceptFileTypes = acceptedFileTypes?.join(',') ?? ACCEPTED_FILE_TYPES_STRING_ALL;
    const open = useCallback(() => {
        inputRef.current?.click();
    }, []);
    const handleChange = useCallback((event) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            onFilesSelected?.(Array.from(files), 'local');
        }
        // Reset input value to allow selecting the same file again
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    }, [onFilesSelected]);
    const handle = useMemo(() => ({
        open,
    }), [open]);
    return (_jsxs(AskInputPlusMenuFileInputContext.Provider, { value: handle, children: [_jsx("input", { ref: inputRef, type: "file", multiple: true, accept: acceptFileTypes, style: { display: 'none' }, onChange: handleChange }), children] }));
});
//# sourceMappingURL=AskInputPlusMenuProvider.js.map